import {onLoad} from './utils/onLoad.js';
import * as gurusup from './chat-gurusup.js';

onLoad(() => {
    gurusup.initChat();
});

const toggleAtcChat = () => {
    gurusup.toggleGurusupBubble();
};

export {toggleAtcChat};
